import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-message.error {\n  border: 1px solid #f50000;\n  background: #ffe6e6;\n  padding: 12px;\n  border-radius: 2px;\n  margin-bottom: 8px;\n}";
  const fileName = "Message_Message_73f56519-7441-47c7-9bc8-26107b7e10cd";
  const element = document.querySelector("style[data-sass-component='Message_Message_73f56519-7441-47c7-9bc8-26107b7e10cd']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Message(props) {
  const classes = ['kof-message', props.type];
  return /*#__PURE__*/_jsx("div", {
    className: classes.join(' '),
    children: props.children
  });
}
Message.propTypes = {
  type: PropTypes.string.isRequired
};
export { Message };